const normalizeString = (str) => str.normalize();

export { normalizeString };
export default normalizeString;
